'use client';

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { useTheme } from 'next-themes';
import {
  Toaster as Sonner,
  type ToasterProps,
  type ExternalToast,
  toast,
} from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      richColors
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--success-bg': 'var(--success-background)',
          '--success-text': 'var(--success-800)',
          '--success-border': 'var(--success-200)',
          '--error-bg': 'var(--error-background)',
          '--error-text': 'var(--error-800)',
          '--error-border': 'var(--error-200)',
          '--info-bg': 'var(--info-background)',
          '--info-text': 'var(--info-800)',
          '--info-border': 'var(--info-200)',
          '--warning-bg': 'var(--warning-background)',
          '--warning-text': 'var(--warning-800)',
          '--warning-border': 'var(--warning-200)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster, toast, type ExternalToast };
